import AddCardWrapper from "components/shared/containers/AddCardWrapper";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UIPrimaryButton, UISecondaryButton } from "components/ui/UIButton";
import React from "react";

/**
 * @function TermsConditionsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for TermsConditionsPage - This is a Video-Only Component
 */

export default function TermsConditionsPage(props) {
  return (
    <AddCardWrapper className="terms-conditions-page">
      <MainContentContainer className="hide-chevron-icon" header={<MainContentHeader text="Terms & Conditions"></MainContentHeader>}>
        <p>Our full Terms and Conditions will appear here. Please take a moment to review it, then Accept.</p>
        <div className="flex-container flex-horizontal align-center-container column-space-around-container">
          <UISecondaryButton text="Decline" dataPoint="accept_terms_button"/>
          <UIPrimaryButton text="Accept" dataPoint="accept_terms_button"/>
        </div>
      </MainContentContainer>
    </AddCardWrapper>
  );
}